import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { IContact } from '@bb/contacts';

const findManyClientsByIds = async (contactIds: string[]) => {
  const config: AxiosRequestConfig = {
    url: '/contacts/findManyClientsByIds',
    method: 'get',
    params: { contactIds },
  };

  const { data } = await axios.request<IContact[]>(config);

  return data;
};

export default findManyClientsByIds;
